<template>
  <div class="app-container">
    <el-form ref="queryForm" :model="queryParams" :inline="true" label-width="68px">
      <el-row>
        <el-form-item label="订单编号">
          <el-input v-model="queryParams.order_no" placeholder="请输入姓名" clearable size="small" />
        </el-form-item>
        <el-form-item label="订单状态">
          <el-select style="width: 100%;" v-model="queryParams.order_status" placeholder="请选择">
            <el-option v-for="item in orderType" :key="item.order_status" :label="item.order_lable"
              :value="item.order_status">
            </el-option>
          </el-select>
        </el-form-item>
      </el-row>
      <el-form-item>
        <el-button type="primary" icon="el-icon-search" :loading="loading" size="mini"
          @click="handleQuery">查询</el-button>
        <!-- <el-button icon="el-icon-refresh" size="mini" @click="resetQuery">重置</el-button> -->
      </el-form-item>
    </el-form>

    <div class="gap"></div>
    <!-- <div style="text-align: left; padding-left: 20px;">
      <el-button type="primary" icon="el-icon-add" :loading="loading" size="mini" @click="handleAdd">新增</el-button>

    </div> -->
    <el-table v-loading="loading" :data="list">
      <el-table-column label="订单编号" align="center" width="140" label-class-name='title' prop="order_no" />
      <!-- <el-table-column label="用户信息" align="center" width="140" label-class-name='title' @click="tres" prop="openid"  /> -->
      <el-table-column label="用户名称" align="center" label-class-name='title' prop="openid">
        <template slot-scope="scope">
          <span class="user" @click="showDetail(scope.row)" >{{ scope.row.user_name   || '用户信息' }}</span>

        </template>

      </el-table-column>
      <!-- <el-table-column label="订单编号" align="center" width="140" label-class-name='title' prop="order_no" /> -->
      <el-table-column label="商品名称" align="center" label-class-name='title' prop="goods_name" />
      <el-table-column label="商品类别" align="center" label-class-name='title' :formatter="transType" prop="goods_type" />
      <el-table-column label="商品售价" align="center" label-class-name='title' prop="goods_price" />
      <el-table-column label="商品图片" align="center" label-class-name='title' prop="goods_url">
        <template slot-scope="scope">
          <img class="img" :src='scope.row.goods_url'></img>

        </template>

      </el-table-column>
      <!-- <el-table-column label="图片地址" align="center" label-class-name='title' prop="goods_url" /> -->
      <el-table-column label="商品描述" align="center" width="200" label-class-name='title' prop="goods_desc" />
      <!-- <el-table-column label="商品原价" align="center" label-class-name='title' prop="origin_price" /> -->
      <el-table-column label="商品数量" align="center" label-class-name='title' prop="order_num" />
      <el-table-column label="商品总价" align="center" :formatter="money" label-class-name='title' prop="goods_url">


      </el-table-column>
      <el-table-column label="订单总价" align="center" label-class-name='title' prop="order_money" />
      <el-table-column label="订单状态" align="center" label-class-name='title' :formatter="statusTrans" prop="order_status" />
      <el-table-column label="配送方式" align="center" label-class-name='title'  prop="peisong" />
      <el-table-column label="操作" align="center" width="200" label-class-name='title'
        class-name="small-padding fixed-width">
        <template slot-scope="scope">
      
        
                      <el-button class="inspect-button" v-if="scope.row.order_status == '1'"  size="mini" type="primary" icon=""
            @click="handleSend(scope.row)">发货</el-button>
            <el-button class="inspect-button" v-if="scope.row.order_status == '2'"  size="mini" type="danger" icon=""
            @click="finished(scope.row)">完成</el-button>
        
            <el-button class="inspect-button"
                       size="mini"
                       type="text"
                       icon="el-icon-view"
                       @click="handleView(scope.row)">详情</el-button>
   
           
        </template>
      </el-table-column>


    </el-table>
    <el-pagination v-show="total > 0" :total="total" @current-change="getList" @prev-click='getList'
      @next-click="getList" />
    <!-- 操作日志详细 -->
    <el-dialog title="用户详情" :visible.sync="open" :close-on-click-modal="false" width="500px" append-to-body>
      <el-form ref="form" :model="form" label-width="100px" size="mini">
          <el-row>
            <el-col :span="24">
              <el-form-item label="用户id：">
              <span>{{ form.openid }}</span>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item label="用户昵称：">
              <span>{{ form.user_name }}</span>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item label="用户电话：">
              <span>{{ form.phone }}</span>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item label="用户地址：">
              <span>{{ form.address }}</span>
              </el-form-item>
            </el-col>
          </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <!-- <el-button type="primary" @click="submit">确定</el-button> -->
        <el-button @click="open = false">关闭</el-button>
      </div>
    </el-dialog>

    <!-- 订单详情 -->
    <el-dialog title="订单详情" :visible.sync="orderOpen" :close-on-click-modal="false" width="600px" append-to-body>
      <el-form ref="orderForm" :model="orderForm" label-width="100px" size="mini">
        <el-row>
          <el-col :span="12">
            <el-form-item label="订单编号：">
              <span>{{ orderForm.order_no }}</span>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="订单状态：">
              <span>{{ statusTrans(orderForm) }}</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="商品图片：">
              <img v-if="orderForm.goods_url" class="detail-img" :src="orderForm.goods_url" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="商品名称：">
              <span>{{ orderForm.goods_name }}</span>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="商品类别：">
              <span>{{ transType(orderForm) }}</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="商品单价：">
              <span>{{ orderForm.goods_price }}</span>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="商品数量：">
              <span>{{ orderForm.order_num }}</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="商品总价：">
              <span>{{ money(orderForm) }}</span>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="订单总价：">
              <span>{{ orderForm.order_money }}</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="商品描述：">
              <span>{{ orderForm.goods_desc }}</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="配送方式：">
              <span>{{ orderForm.peisong }}</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-divider content-position="left">用户信息</el-divider>
        <el-row>
          <el-col :span="24">
            <el-form-item label="用户ID：">
              <span>{{ orderForm.openid }}</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="用户昵称：">
              <span>{{ orderForm.user_name }}</span>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="用户电话：">
              <span>{{ orderForm.phone }}</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="用户地址：">
              <span>{{ orderForm.address }}</span>
            </el-form-item>
          </el-col>
        </el-row>
             <el-divider content-position="left">配送信息</el-divider>
             <el-row>
          <el-col :span="12">
            <el-form-item label="快递公司：">
              <span>{{ orderForm.peisong }}</span>
            </el-form-item>
          </el-col>
     
          <el-col :span="12">
            <el-form-item label="发货人姓名：">
              <span>{{ orderForm.sender }}</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="发货人电话：">
              <span>{{ orderForm.senderPhone }}</span>
            </el-form-item>
          </el-col>
    
          <el-col :span="12">
            <el-form-item label="订单编号：">
              <span>{{ orderForm.postid }}</span>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="orderOpen = false">关闭</el-button>
      </div>
    </el-dialog>

    <!-- 发货 -->
    <el-dialog title="发货" :visible.sync="sendOpen" :close-on-click-modal="false" width="500px" append-to-body>
      <el-form ref="sendFormRef" :model="sendForm" :rules="sendRules" label-width="100px" size="mini">
        <el-row>
          <el-col :span="24">
            <el-form-item label="订单编号：">
              <span>{{ sendForm.order_no }}</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="快递公司" prop="peisong">
              <el-input v-model="sendForm.peisong" placeholder="请输入快递公司" clearable />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="发货人姓名：" prop="sender">
              <el-input v-model="sendForm.sender" placeholder="请输入发货人姓名" clearable />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="发货人电话：" prop="senderPhone">
              <el-input v-model="sendForm.senderPhone" placeholder="请输入发货人电话" clearable />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="订单编号：" prop="postid">
              <el-input v-model="sendForm.postid" placeholder="请输入订单编号" clearable />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="sendOpen = false">取消</el-button>
        <el-button type="primary" @click="submitSend">确定</el-button>
      </div>
    </el-dialog>

  </div>



</template>

<script>
import config from '../../config/config'
import { typeAdd, typeList, typeDelete, typeUpdate } from '../api/type/index';
import { goodsAdd, goodsList, goodsDelete, goodsUpdate } from '../api/goods/index';
import { ordersPageList, ordersUpdate } from '../api/orders/index';
import { preAbortOrder ,abortOrder} from '../api/shansong/shansong';

export default {
  name: 'Operlog',
  data () {
    return {
      shansongType: [
        { orderStatus: '', shansong_lable: '全部' },
        { orderStatus: '20', shansong_lable: '派单中' },
        { orderStatus: '30', shansong_lable: '待取货' },
        { orderStatus: '40', shansong_lable: '闪送中' },
        { orderStatus: '50', shansong_lable: '已完成' },
        { orderStatus: '60', shansong_lable: '已取消' }
      ],
      orderType: [
        { order_status: '', order_lable: '全部' },
        { order_status: '1', order_lable: '已支付' },
        { order_status: '2', order_lable: '已发货' },
        { order_status: '3', order_lable: '已完成' }
      ],
      typeList: [],
      limit: 2,
      baseURL: '',  //  图片上传地址
      dialogImageUrl: '',
      dialogVisible: false,
      disabled: false,


      list: [],
      form: {

      },
      open: false,
      orderOpen: false,
      orderForm: {},
      sendOpen: false,
      sendForm: {
        order_no: '',
        sender: '',
        senderPhone: '',
        postid: ''
      },
      sendRules: {
        sender: [
          { required: true, message: '请输入发货人姓名', trigger: 'blur' }
        ],
        senderPhone: [
          { required: true, message: '请输入发货人电话', trigger: 'blur' },
          { pattern: /^1[3-9]\d{9}$/, message: '请输入正确的手机号', trigger: 'blur' }
        ],
        postid: [
          { required: true, message: '请输入订单编号', trigger: 'blur' }
        ]
      },
      pageIndex: 1,
      pageSize: 10,
      // 禁用状态
      disabled: false,
      queryParams: {

      },
      loading: false,
      // table 列表数据
      list: [],
      // 总条数
      total: 0,

    }
  },

  created () {
    this.action = config.baseUrl + 'manageSystem/staticImageUpload';
    console.log(this.action)
    this.handleQuery();

    typeList({}).then(res => {
      this.typeList = res.data.list;
      console.log(res.data.list)
    })
  },
  methods: {
    //  取消闪送订单
    shansongCancel(row){
      debugger
      console.log(row)
      let params = {
        issOrderNo:row.orderNo
      }
      if(!row.orderNo){
        return  this.$message.error('未找到闪送订单')
      }
      preAbortOrder(params).then(res => {
        debugger
        console.log('---sss---',res)
        let str = `需要送回费用 ${res.data.sendBackFee} 元，扣费 ${res.data.punishAmount} 元，是否确认取消订单？`
            this.$confirm(str).then(() => {
          abortOrder(params).then(res => {
            this.$message.success('取消成功')
            this.handleQuery()
          })
        })
        .catch(_ => { });
      })
    },
    // 
    showDetail(row){
      console.log(row)
      this.form = row;
      this.open = true
    },
    //  查看订单详情
    handleView (row) {
      this.orderForm = row
      this.orderOpen = true
    },
    //  单品总价
    money (row) {
      return row.order_num * row.goods_price
    },
    //  订单状态
    statusTrans(row){
      let list = this.orderType;
      for(let i=0;i<list.length;i++){
        if(list[i].order_status == row.order_status){
          return list[i].order_lable
        }
      }
    },
    handleUpdate (row) {
      this.open = true;
      this.form = {
        goods_id: row.goods_id,
        goods_url: row.goods_url,
        goods_name: row.goods_name,
        goods_price: row.goods_price,
        goods_desc: row.goods_desc,
        origin_price: row.origin_price,
        goods_num: row.goods_num,
        goods_type: row.goods_type - 0,
      }
    },
    //  发货
    handleSend (row) {
      this.sendForm = {
        order_no: row.order_no,
        sender: '',
        senderPhone: '',
        postid: ''
      }
      this.sendOpen = true
      this.$nextTick(() => {
        this.$refs.sendFormRef && this.$refs.sendFormRef.clearValidate()
      })
    },
    //  提交发货
    submitSend () {
      this.$refs.sendFormRef.validate(valid => {
        if (!valid) return
        let params = {
          order_no: this.sendForm.order_no,
          order_status: '2',
          sender: this.sendForm.sender,
          senderPhone: this.sendForm.senderPhone,
          postid: this.sendForm.postid,
          peisong: this.sendForm.peisong
        }
        console.log(params)
        ordersUpdate(params).then(res => {
          this.$message.success('发货成功')
          this.sendOpen = false
          this.handleQuery()
        }).catch(_ => {})
      })
    },
    //  取消发货
    
    finished(row) {
      let params = {
        order_no: row.order_no,
        order_status: '3'
      }
      
      this.$confirm('确认完成订单吗？')
        .then(() => {
          ordersUpdate(params).then(res => {
            this.$message.success('完成成功') 
            this.handleQuery()
          })
        })
        .catch(_ => { });

    },
    submit () {
      console.log(this.form)

      let params = this.form;
      console.log(params)
      if (!params.goods_url) {
        return this.$message.error('请输入商品地址')
      }
      if (!params.goods_name) {
        return this.$message.error('请输入商品名称')
      }
      if (!params.goods_price) {
        return this.$message.error('请输入商品价格')
      }
      if (!params.goods_desc) {
        return this.$message.error('请输入商品描述')
      }
      if (!params.origin_price) {
        return this.$message.error('请输入商品原价')
      }
      if (!params.goods_num) {
        return this.$message.error('请输入商品数量')
      }
      if (!params.goods_type) {
        return this.$message.error('请输入商品类别')
      }

      if (!params.goods_id) {
        goodsAdd(this.form).then(res => {
          this.$message.success('新增成功')
          this.open = false
          this.handleQuery()
        })
      } else {
        goodsUpdate(this.form).then(res => {
          this.$message.success('修改成功')
          console.log(res)
          this.open = false
          this.handleQuery()
        })
      }
    },

    // 类别
    transType (row) {
      let list = this.typeList
      for (let i = 0; i < list.length; i++) {
        if (list[i].type_code == row.goods_type) {
          return list[i].type_name
        }
      }
    },
    // 类别
    transorder_status (row) {
      if(row.order_status == '3'){
        return '已取货'
      }else{
        return ''
      }
    },

    //  退出
    logout () {
      localStorage.clear();
      this.$router.push('/')
    },
    // 新增按钮
    handleAdd () {
      this.open = true
      this.form = {
      }
    },
    // 查询按钮
    handleQuery () {
      let params = this.queryParams;
      params.pageIndex = this.pageIndex;
      params.pageSize = this.pageSize;

      this.list = []
      ordersPageList(params).then(res => {
        
        this.list = res.data.list;
        console.log(this.list)
        this.total = res.data.total
        console.log(this.total)
      })
    },

    //  上一页面
    preClick (e) {
      this.pageIndex = e;
      if (pageIndex <= 1) { return }
      this.handleQuery()
    },
    // 下一页
    preClick () {
      let pageIndex = this.pageIndex + 1;

      if (pageIndex * this.pageSize >= this.total) {
        return
      }
      this.pageIndex = pageIndex;
      this.handleQuery()
    },
    // 获取列表
    getList (e) {
      this.pageIndex = e
      let params = {
        pageIndex: this.pageIndex,
        pageSize: this.pageSize,
      }
      ordersPageList(params).then(res => {

        this.list = res.data.list;
        this.total = res.data.total
        console.log(this.total)
      })
    }
  }
}
</script>
<style>
.app-container {
  margin-top: 40px;
}

.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}

.avatar {
  width: 178px;
  height: 178px;
  display: block;
}

.gap {
  margin: 30px 10px;
}

.title {
  color: black;
}

.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409EFF;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}

.avatar {
  width: 178px;
  height: 178px;
  display: block;
}

.img {
  width: 50px;
  height: 50px;
  margin-left: 10px;
}

.el-upload-list--picture-card .el-upload-list__item {
  width: 100px;
  height: 100px !important;
}

.el-upload--picture-card {
  width: 100px;
  height: 100px !important;
  line-height: 100px;
}

.img {
  width: 100px;
  height: 100px;
}

.detail-img {
  width: 80px;
  height: 80px;
  border-radius: 4px;
}
</style>


// WEBPACK FOOTER //
// src/views/orders.vue